const style = document.createElement("style");
style.innerHTML = `
    #area-tbody {
        font-size: 14px;
        font-weight: 500;
    }
    @media (min-width: 768px) {
        #area-tbody {
            font-size: 16px;
        }
        .investment-target {
            width: 184px;
        }
    }
`;
document.head.appendChild(style);

// url參數
let scriptId = document.getElementById("fundAreaRatioScript");

let mfxId =
  scriptId && scriptId.attributes["mfx-id"]
    ? scriptId && scriptId.attributes["mfx-id"].value
    : "ALGW";

// 數字格式化
function NumFormatter(num, decimal) {
  this.value =
    num !== null && num !== undefined
      ? num.toLocaleString(undefined, {
          minimumFractionDigits: decimal,
          maximumFractionDigits: decimal,
        })
      : "--";

  this.addPercent = function () {
    this.value =
      num !== null && num !== undefined ? `${this.value}%` : this.value;
    return this;
  };

  this.addPrefix = function () {
    if (num > 0) this.value = `+${this.value}`;
    if (num < 0) this.value = `${this.value}`;
    return this;
  };
}

function numHandler(num, decimal = 2) {
  return new NumFormatter(num, decimal);
}

function formatPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().value; // 12.55%
}

function formatReturnPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().addPrefix().value; //+12.55%
}

function numTextColor(num) {
  if (num !== null && num !== undefined) {
    return num > 0
      ? "text-red-500"
      : num < 0
      ? "text-green-500"
      : "text-gray-500";
  } else {
    return "text-gray-800";
  }
}

// 渲染數據區塊
function renderAreaDataBlock(data) {
  const tbody = document.getElementById("area-tbody");
  tbody.innerHTML = "";
  data.forEach((item, index) => {
    const row = renderAreaDataRow(item, index);
    tbody.insertAdjacentHTML("beforeend", row);
  });
}

function renderAreaDataHead() {
  const thead = document.getElementById("area-thead");
  thead.innerHTML = `
            <tr>
                <th style="font-weight: 500; font-size: 14px; text-align: left; padding-left: 16px; padding-top: 8px; padding-bottom: 8px; color: #333333;">
                    投資標的
                </th>
                <th>
                    <div style="display:flex; justify-content: flex-end; align-items: center; font-weight: 500; font-size: 14px; color: #333333; padding: 8px 0px">
                        <span>本次％</span>
                        <div id="sort-current" style="display: flex; flex-direction: column; margin-left: 4px;">
                            <div id="area-current-asc" style="height: 12px; cursor: pointer; color: #CCCCCC">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" style="width: 10px; height: 10px; pointer-events: none; transform: translateY(-2px)"><path fill="currentColor" d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"></path></svg>
                            </div> 
                            <div id="area-current-desc" style="height: 12px; cursor: pointer; color: #CCCCCC">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" style="width: 10px; height: 10px; pointer-events: none; transform: translateY(-6px)"><path fill="currentColor" d="M182.6 250.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"></path></svg>
                            </div> 
                        </div>
                    </div>
                </th>
                <th>
                    <div style="display:flex; justify-content: flex-end; align-items: center; font-weight: 500; font-size: 14px; color: #333333; padding: 8px 0px">
                        <span>前次％</span>
                        <div id="sort-previous" style="display: flex; flex-direction: column; margin-left: 4px;">
                            <div id="area-previous-asc" style="height: 12px; cursor: pointer; color: #CCCCCC">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" style="width: 10px; height: 10px; pointer-events: none; transform: translateY(-2px)"><path fill="currentColor" d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"></path></svg>
                            </div> 
                            <div id="area-previous-desc" style="height: 12px; cursor: pointer; color: #CCCCCC">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" style="width: 10px; height: 10px; pointer-events: none; transform: translateY(-6px)"><path fill="currentColor" d="M182.6 250.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"></path></svg>
                            </div> 
                        </div>
                    </div>
                </th>
                <th>
                    <div style="display:flex; justify-content: flex-end; align-items: center; font-weight: 500; font-size: 14px; color: #333333; padding: 8px 16px 8px 0px">
                        <span>變化％</span>
                        <div id="sort-change" style="display: flex; flex-direction: column; margin-left: 4px;">
                            <div id="area-change-asc" style="height: 12px; cursor: pointer; color: #CCCCCC">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" style="width: 10px; height: 10px; pointer-events: none; transform: translateY(-2px)"><path fill="currentColor" d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"></path></svg>
                            </div> 
                            <div id="area-change-desc" style="height: 12px; cursor: pointer; color: #CCCCCC">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 320" style="width: 10px; height: 10px; pointer-events: none; transform: translateY(-6px)"><path fill="currentColor" d="M182.6 250.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"></path></svg>
                            </div> 
                        </div>
                    </div>
                </th>
            </tr>
        `;
        const sortButtons = ['current', 'previous', 'change'];
        sortButtons.forEach(column => {
          const button = document.getElementById(`sort-${column}`);
          if (button) {
            button.addEventListener('click', () => sortAreaData(column));
          }
        });
}

function renderAreaDataRow(data, index) {
  return `
        <tr style="${index % 2 === 1 ? "background: #F5F5F5" : ""}">
          <td style="padding-left: 16px; padding-top: 8px; padding-bottom: 8px; text-align: left; width: 184px;" class="investment-target">${
            data.name
          }</td>
          <td style="text-align: right;">${formatPercent(
            data.value.current * 100
          )}</td>
          <td style="text-align: right;">${formatPercent(
            data.value.previous * 100
          )}</td>
          <td style="padding: 8px 16px; text-align: right;" class="${numTextColor(
            data.value.change
          )}">${formatReturnPercent(data.value.change * 100)}</td>
        </tr>
          `;
}

let isAreaExpanded = false;
/* eslint-disable-next-line no-unused-vars */
function areaCheckMore() {
  isAreaExpanded = !isAreaExpanded;
  const displayedData = isAreaExpanded
    ? areaRatio.data // 展示全部數據
    : areaRatio.data.slice(0, 5); // 只展示前 5 筆

  // 重新渲染數據
  renderAreaDataBlock(displayedData);
  // 更新按鈕文字
  const areaCheckMoreButton = document.getElementById("areaCheckMore");
  areaCheckMoreButton.querySelector("div:first-child").textContent =
    isAreaExpanded ? "收合" : "看更多";
  // 切換箭頭旋轉效果
  const arrow = document.getElementById("areaCheckMoreArrow");
  arrow.style.transform = isAreaExpanded ? "rotate(180deg)" : "rotate(0deg)";
}

let sortedColumn;
let order = "asc";
/* eslint-disable-next-line no-unused-vars */
function sortAreaData(column) {
  if (sortedColumn === column) {
    order = order === "asc" ? "desc" : "asc";
  } else {
    sortedColumn = column;
    order = "asc";
  }

  let data = areaRatio.data.sort((a, b) => {
    const valueA = a.value[column];
    const valueB = b.value[column];

    if (order === "asc") {
      return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
    } else if (order === "desc") {
      return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
    } else {
      console.error("Invalid order specified. Use 'asc' or 'desc'.");
      return 0;
    }
  });

  let columns = ["current", "previous", "change"];
  columns.forEach((col) => {
    let asc = document.getElementById(`area-${col}-asc`);
    let desc = document.getElementById(`area-${col}-desc`);
    if (col === column) {
      if (order === "asc") {
        asc.style.color = "#FF9664";
        desc.style.color = "#CCCCCC";
      } else {
        asc.style.color = "#CCCCCC";
        desc.style.color = "#FF9664";
      }
    } else {
      asc.style.color = "#CCCCCC";
      desc.style.color = "#CCCCCC";
    }
  });

  isAreaExpanded
    ? renderAreaDataBlock(data)
    : renderAreaDataBlock(data.slice(0, 5));
}

let areaRatio;
function loadScript() {
  const targetElement = document.getElementById("fundAreaRatioScript");

  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}/portfolio`;
  fetch(url)
    .then((response) => {
      // 檢查回應是否成功
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // 將回應轉換為 JSON 格式
    })
    .then((data) => {
      //建立基本資料區域
      areaRatio = data.country;
      const areaRatioInfo = document.createElement("div");

      //渲染基本資料
      if (areaRatio.data && areaRatio.data.length > 0) {
        const showMoreButton = areaRatio.data.length > 5 ? `
          <div id="areaCheckMore" style="display: flex; justify-content: center; align-items: center; cursor: pointer; font-size: 14px; margin-top: 8px; width: 100%; color: #666666; font-weight: 500;">
              <div style="margin-right: 2px">看更多</div>
              <div id="areaCheckMoreArrow" style="width: 14px; transition: transform 0.3s;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
              </div>
          </div>
        ` : '';

        areaRatioInfo.innerHTML = `
        <div>
            <div style="color: #333333; font-weight: 500; font-size: 18px; margin-bottom: 8px;">
                區域分布
                <span style="font-size: 14px; color: #999999">${areaRatio.yearMonth} 更新</span>
            </div>

            <div style="border-radius: 4px; overflow: hidden; border: 1px solid #E0E0E0;">
                <table style="border-collapse: collapse; table-layout: fixed; width: 100%;">
                    <thead id="area-thead" style="background-color: #E0E0E0; white-space: nowrap;"></thead>
                    <tbody id="area-tbody"></tbody>
                </table>
            </div>

            ${showMoreButton}
        </div>
    `;

        targetElement.innerHTML = '';
        targetElement.appendChild(areaRatioInfo);
        renderAreaDataHead();
        renderAreaDataBlock(areaRatio.data.slice(0, 5));
        const areaCheckMoreButton = document.getElementById("areaCheckMore");
        if (areaCheckMoreButton) {
          areaCheckMoreButton.addEventListener('click', areaCheckMore)
        }
      } else {
        let noData = document.createElement("div");
        noData.innerHTML = `
          <div>
             <div style="color: #333333; font-weight: 500; font-size: 18px; margin-bottom: 8px;">
                區域分布
            </div>
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 184px;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="54" height="54"><path fill="#EBEBEB" d="M567.9 243.9L462.3 85.4A48 48 0 0 0 422.3 64H153.7a48 48 0 0 0 -39.9 21.4L8.1 243.9A48 48 0 0 0 0 270.5V400c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V270.5a48 48 0 0 0 -8.1-26.6zM162.3 128h251.5l85.3 128H376l-32 64H232l-32-64H76.9l85.3-128z"/></svg>
              <div style="color: #999999; font-size: 14px; margin-top: 8px; width: 100%; font-weight: 500; text-align: center">暫無資料</div>
            </div>
          </div>
        `;

        targetElement.innerHTML = '';
        targetElement.appendChild(areaRatioInfo);
        areaRatioInfo.appendChild(noData);
      }
    })
    .catch((error) => {
      // 捕獲並處理錯誤
      console.error("發生錯誤:", error);
    });
}

loadScript();
